import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ONBOARDING } from '../data';

const STORAGE_KEY = 'rv-onboarding-done';

function readDone(): Record<string, boolean> {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
      return {};
    }
    const result: Record<string, boolean> = {};
    for (const [k, v] of Object.entries(parsed as Record<string, unknown>)) {
      if (typeof v === 'boolean') result[k] = v;
    }
    return result;
  } catch {
    return {};
  }
}

export function Quickstart() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Quickstart — Revvly Subscription Management Docs';
  }, []);

  const [done, setDone] = useState<Record<string, boolean>>(readDone);

  const toggle = (key: string) => {
    const next = { ...done, [key]: !done[key] };
    setDone(next);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      // ignore
    }
  };

  return (
    <div className="qs-wrap">
      <header className="qs-header dp-header" style={{ marginBottom: 0 }}>
        <span className="rv-eyebrow-mini">Quickstart</span>
        <h1>
          From <em>nothing</em> to first invoice.
        </h1>
        <p className="dp-oneliner">
          Three phases, walked in order. Tap any step to open its concept page. Checkmarks save
          locally — pick it up where you left off.
        </p>
      </header>
      {ONBOARDING.map((phase, pi) => (
        <section className="qs-phase" key={pi}>
          <div className="qs-phase-head">
            <span className="qs-phase-num">{phase.phase}</span>
            <h2>{phase.title}</h2>
          </div>
          <p>{phase.subtitle}</p>
          <ol className="qs-steps">
            {phase.steps.map((step, si) => {
              const key = `${pi}-${si}`;
              const checked = !!done[key];
              return (
                <li key={si} className={`qs-step ${checked ? 'qs-step-done' : ''}`}>
                  <button
                    className="qs-step-check"
                    onClick={() => toggle(key)}
                    aria-pressed={checked}
                    aria-label={checked ? 'Mark incomplete' : 'Mark complete'}
                  >
                    {checked ? '✓' : ''}
                  </button>
                  <div>
                    <div className="qs-step-label">{step.label}</div>
                    <div className="qs-step-detail">{step.detail}</div>
                  </div>
                  <Link className="qs-step-open" to={`/docs/concepts/${step.entity}`}>
                    Open ›
                  </Link>
                </li>
              );
            })}
          </ol>
        </section>
      ))}
    </div>
  );
}
